import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook } from 'lucide-react';
import Logo from './Logo';

const COLS = [
  { title: 'Studio', links: [['Work', '/work'], ['Services', '/services'], ['Pricing', '/pricing'], ['Contact', '/contact']] },
  { title: 'Explore', links: [['Industries', '/industries'], ['Ads that convert', '/ads'], ['Demos', '/demos'], ['Client hub', '/hub']] },
  { title: 'Products', links: [['Nighthouse', 'https://nighthouse.app'], ['Postify', 'https://postify.social'], ['FillAI', 'https://fillai.postify.social'], ['ValidMy.email', 'https://validmy.email']] },
  { title: 'Legal', links: [['Terms and conditions', '/terms.html'], ['Sign in', '/login'], ['Register', '/register']] },
];

function FooterLink({ label, href }) {
  const cls = 'text-sm text-mist hover:text-cream transition-colors';
  if (href.startsWith('http')) {
    return <a href={href} target="_blank" rel="noopener noreferrer" className={cls}>{label}</a>;
  }
  if (href.endsWith('.html')) return <a href={href} className={cls}>{label}</a>;
  return <Link to={href} className={cls}>{label}</Link>;
}

export default function Footer() {
  const iconCls = 'flex h-10 w-10 items-center justify-center rounded-full border border-line text-mist hover:text-cream hover:border-cream/40 transition-colors';
  return (
    <footer className="border-t border-line bg-ink">
      <div className="container-x grid gap-12 py-16 md:grid-cols-[1.4fr_repeat(4,1fr)] md:py-20">
        <div>
          <div className="flex items-center gap-2.5">
            <Logo className="h-7 w-7" />
            <span className="font-display text-xl font-semibold">Blu<span className="text-sky">prise</span></span>
          </div>
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-mist">
            Websites, SEO, AI, API Integrations, AGI Bots and Travel Tech. Based in Dover, Delaware. Builders of BluBeds.
          </p>
          <div className="mt-6 flex gap-3">
            <a href="https://www.instagram.com/bluprise" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className={iconCls}>
              <Instagram className="h-4 w-4" />
            </a>
            <a href="https://www.facebook.com/bluprise" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className={iconCls}>
              <Facebook className="h-4 w-4" />
            </a>
          </div>
        </div>
        {COLS.map((col) => (
          <div key={col.title}>
            <p className="text-sm font-medium text-cream">{col.title}</p>
            <ul className="mt-4 space-y-2.5">
              {col.links.map(([label, href]) => (
                <li key={label}><FooterLink label={label} href={href} /></li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-line">
        <div className="container-x flex flex-col gap-2 py-6 text-xs text-dim sm:flex-row sm:items-center sm:justify-between">
          <p>Bluprise LLC, 8 The Green, Dover, DE 19901, United States</p>
          <p>Copyright {new Date().getFullYear()} Bluprise LLC. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
